import { render, staticRenderFns } from "./c_tab.vue?vue&type=template&id=077e6c40&scoped=true&"
import script from "./c_tab.vue?vue&type=script&lang=js&"
export * from "./c_tab.vue?vue&type=script&lang=js&"
import style0 from "./c_tab.vue?vue&type=style&index=0&id=077e6c40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077e6c40",
  null
  
)

export default component.exports